import { useCurrentFrame, interpolate, useVideoConfig, AbsoluteFill } from "remotion";

/**
 * Small "Watch full video on YouTube" CTA box — YouTube icon + label.
 * Transparent overlay; sits bottom-centre. Sized for 3:4 (960×1280) but
 * position is %-based so it adapts to any canvas.
 */
export const ReelYouTubeCTA: React.FC<{ bottomPct?: number; durationInFrames?: number }> = ({ bottomPct = 4 }) => {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  const fadeIn = interpolate(frame, [0, 7], [0, 1], { extrapolateRight: "clamp" });
  const fadeOut = interpolate(frame, [durationInFrames - 7, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const pop = interpolate(frame, [0, 7], [0.86, 1], { extrapolateRight: "clamp" });
  const pulse = 1 + Math.sin(frame * 0.22) * 0.02;
  const opacity = fadeIn * fadeOut;

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div
        style={{
          position: "absolute",
          bottom: `${bottomPct}%`,
          left: "50%",
          transform: `translateX(-50%) scale(${pop * pulse})`,
          opacity,
          whiteSpace: "nowrap",
        }}
      >
        {/* icon + text only, on alpha (no box) */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* YouTube logo — rounded red box + white play triangle */}
          <svg width="40" height="28" viewBox="0 0 28 20" style={{ display: "block", filter: "drop-shadow(0 2px 5px rgba(0,0,0,0.7))" }}>
            <rect width="28" height="20" rx="6" fill="#FF0000" />
            <polygon points="11,5.4 11,14.6 19.2,10" fill="#ffffff" />
          </svg>
          <span
            style={{
              color: "#ffffff",
              fontSize: 28,
              fontWeight: 800,
              fontFamily: "'Arial Black', 'Arial', sans-serif",
              letterSpacing: "0.01em",
              textShadow: "0 2px 7px rgba(0,0,0,0.95), 0 0 3px rgba(0,0,0,0.8)",
            }}
          >
            Watch full video on{" "}
            <span style={{ color: "#FF3B30" }}>YouTube</span>
          </span>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
